// src/App.jsx
import React, { useEffect } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import theme from "./theme";

import { AuthProvider } from "./context/AuthContext";

import AnnouncementBar from "./components/AnnouncementBar";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import MissionSection from "./components/MissionSection";
import TechnologySection from "./components/TechnologySection";
import AISection from "./components/AISection";
import ContactSection from "./components/ContactSection";
import Partners from "./pages/Partners";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import CarbonBridgePolicyArchitecture from "./pages/CarbonBridgePolicyArchitecture.tsx";
import AiRequestToolkit from './pages/AiRequestToolkit';
import BrokerAssistantPromptDoc from "./pages/BrokerAssistantPromptDoc.tsx";
import CarbonCreditRulesDoc from "./pages/CarbonCreditRulesDoc.tsx";
import CarbonBridgeTestPlanDoc from "./pages/CarbonBridgeTestPlanDoc.tsx";
import CarbonBridgeTestCasesDoc from "./pages/CarbonBridgeTestCasesDoc.tsx";
import Docs from "./pages/Docs.tsx";

function AppContent() {
  const location = useLocation();

  // 🔑 This is what makes scroll-from-other-pages work
  useEffect(() => {
    if (location.pathname === "/" && location.state?.scrollTo) {
      const { scrollTo } = location.state;

      // small delay so sections are rendered
      setTimeout(() => {
        if (scrollTo === "top") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          const el = document.getElementById(scrollTo);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        window.history.replaceState({}, document.title, "/");
      }, 300);
    }
  }, [location]);

  return (
    <>
      <AnnouncementBar />
      <AuthProvider>
        <NavBar />
        <Routes>

          <Route path="/ai-dashboard" element={<AiRequestToolkit />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />


          <Route
            path="/"
            element={
              <>
                <Hero />
                <AboutSection />
                <MissionSection />
                <AISection />
                <TechnologySection />
                <ContactSection />
              </>
            }
          />
          <Route path="/docs" element={<Docs />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/policy" element={<CarbonBridgePolicyArchitecture />} />
          <Route path="/broker-assistant" element={<BrokerAssistantPromptDoc />} />
          <Route path="/carbon-rules" element={<CarbonCreditRulesDoc />} />
          <Route path="/test-plans" element={<CarbonBridgeTestPlanDoc />} />
          <Route path="/test-cases" element={<CarbonBridgeTestCasesDoc />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <>
                <Route path="/ai-dashboard" element={<AiRequestToolkit />} />
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              </>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
      {/* If your Footer is imported, keep it here */}
      {/* <Footer /> */}
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}
